import type { ReactNode } from "react";

export function PageLayout(props: {
  title: ReactNode;
  /** A trail back to where this page was opened from, shown above the title. */
  breadcrumb?: ReactNode;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div>
      <div className="pageHeader">
        <div>
          {props.breadcrumb ? <div className="muted" style={{ marginBottom: 4 }}>{props.breadcrumb}</div> : null}
          <h1 className="h1">{props.title}</h1>
          {props.description && <div className="muted desc">{props.description}</div>}
        </div>
        {props.actions ? <div className="actions">{props.actions}</div> : null}
      </div>
      {props.children}
    </div>
  );
}

